import { Box, CircularProgress, ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { EntityPostDetails, YourPosts } from "../../models/posts";
import { abbreviateNumber, icon, IMAGE_RESIZE_PATH, SELLER } from "../../common/common";
import { getAPIAsync } from "../../api/apiCalls";
import { isMobileOnly, isTablet } from "react-device-detect";
import Provider from "../../api/provider";
import { FollowersNullSet } from "../nullSets/chatNullset";

let isAjaxCalling: boolean = false;

const MyPostsTab = ({ onMyPostClick, senderID, ucnum }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [yourPostData, setYourPostData] = useState<YourPosts>();
  const [pageNumberYour, setPageNumberYour] = useState<number>(1);
  const [allPostLoaded, setAllPostLoaded] = useState<boolean>(false);

  const onYourScrollEvent = (e: any) => {
    const $eTarget = e.currentTarget;
    if (!isAjaxCalling && $eTarget.scrollHeight - $eTarget.scrollTop <= $eTarget.clientHeight && !allPostLoaded) {
      setPageNumberYour(pageNumberYour + 1);
    }
  };

  const PostCallbackSuccess = (response: any) => {
    setIsLoading(false);
    const yourPosts: YourPosts = response.data;
    let appendedData: EntityPostDetails[] = [];
    if (yourPostData) {
      appendedData = [...yourPostData.entityPostDetails, ...yourPosts.entityPostDetails];
    } else {
      appendedData = [...yourPosts.entityPostDetails];
    }
    yourPosts.entityPostDetails = appendedData;
    if (yourPosts.entityPostDetails.length >= yourPosts.totalPosts) {
      setAllPostLoaded(true);
    }
    isAjaxCalling = false;
    setYourPostData(yourPosts);
  };

  const PostCallbackFailure = () => {
    setIsLoading(false);
    isAjaxCalling = false;
    setAllPostLoaded(true);
  };

  const onImageClick = (epd: EntityPostDetails) => {
    onMyPostClick && onMyPostClick(epd);
  };

  useEffect(() => {
    let url: string = Provider.API_URLS.YourPosts;
    const params: any = {
      ucnum: senderID,
      isAllPostsCount: true,
      pageSize: 12,
      pageNo: pageNumberYour,
    };

    if (SELLER) {
      url = Provider.API_URLS.YourPostsStore;
      params.ucnum = encodeURIComponent(ucnum);
      params.scnum = senderID;
    }
    isAjaxCalling = true;
    getAPIAsync(Provider.URLS.BASE_URL, url, params, PostCallbackSuccess, PostCallbackFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumberYour]);

  return (
    <>
      {isLoading ? (
        <Box className="pos-abs w-per-100 h-per-100 display-flex display-flex-justify-center">
          <CircularProgress sx={{ width: "24px", height: "24px" }} />
        </Box>
      ) : yourPostData && yourPostData.entityPostDetails && yourPostData.entityPostDetails.length > 0 ? (
        <Box className="post-image-list w-per-100 h-per-100 pos-abs pad-b-16" sx={{ overflowY: "auto" }} onScroll={onYourScrollEvent}>
          <ImageList sx={{ width: "100%", marginBottom: "0px" }} cols={3} rowHeight={isTablet ? 286 : 150} gap={1}>
            {yourPostData.entityPostDetails.map((epd: EntityPostDetails, i: number) => {
              return (
                <ImageListItem
                  key={i}
                  onClick={() => {
                    onImageClick(epd);
                  }}
                >
                  <img alt={epd.postAttributes.entityMedia.filename} src={`${IMAGE_RESIZE_PATH}${epd.postAttributes.entityMedia.folderPath}/${SELLER ? (epd.postAttributes.entityMedia.coverPosition ? epd.postAttributes.entityMedia.coverPosition : epd.postAttributes.entityMedia.filename.replace(".mp4", ".jpeg")) : epd.postAttributes.entityMedia.filename.replace(".mp4", ".jpeg")}?preset=120`} style={{ height: isTablet ? "286px" : "150px", objectFit: "cover" }} loading="lazy" />
                  <ImageListItemBar
                    className="share-post-holder w-per-100"
                    sx={{ p: 0.5, background: "linear-gradient(180deg, rgba(22, 24, 35, 0.0001) 2.92%, rgba(22, 24, 35, 0.3) 98.99%)" }}
                    actionPosition="left"
                    actionIcon={
                      <Box className="w-per-100 display-flex flex-direction-row flex-space-between display-flex-center">
                        <Box className="w-per-100 display-flex flex-direction-row display-flex-center">
                          {icon({ iconName: "play_arrow", iconSize: "size-16", iconColor: "icon-true-white", iconCustomClass: "mar-r-4" })}
                          <Typography variant="body2" className="icon-true-white ft-12" sx={{ lineHeight: "unset" }}>
                            {epd.postAttributes.stats ? abbreviateNumber(epd.postAttributes.stats.view_count) : 0}
                          </Typography>
                        </Box>
                      </Box>
                    }
                  />
                </ImageListItem>
              );
            })}
          </ImageList>
        </Box>
      ) : (
        <Box className={`inboxContentContainerEmpty ${isMobileOnly ? "mar-t-16" : "mar-t-24"}`}>
          <FollowersNullSet header="No posts yet" body="Your posts will appear here" />
        </Box>
      )}
    </>
  );
};

export default MyPostsTab;
